// extracted by mini-css-extract-plugin
export default {"inpClass":"Input_inpClass__bshcr"};